import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Transactions from './pages/Transactions';
import Subscriptions from './pages/Subscriptions';
import Devices from './pages/Devices';
import Analytics from './pages/Analytics';
import Config from './pages/Config';
import AdminLogs from './pages/AdminLogs';
import Plans from './pages/Plans';
import UserDetail from './pages/UserDetail';
import Broadcast from './pages/Broadcast';
import Lodges from './pages/Lodges';
import LodgeDetail from './pages/LodgeDetail';
import AccessPoints from './pages/AccessPoints';
import Payments from './pages/Payments';
import Sessions from './pages/Sessions';
import Outages from './pages/Outages';
import Credits from './pages/Credits';

import './index.css';

function ProtectedRoute({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg)' }}>
      <div style={{ width: 28, height: 28, border: '2px solid #1e2330', borderTopColor: '#4f8ef7', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }} />
    </div>
  );
  return admin ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return null;
  return admin ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index                  element={<Dashboard />}    />
              <Route path="users"           element={<Users />}        />
              <Route path="users/:id"       element={<UserDetail />}   />
              <Route path="transactions"    element={<Transactions />} />
              <Route path="subscriptions"   element={<Subscriptions />}/>
              <Route path="plans"           element={<Plans />}        />
              <Route path="devices"         element={<Devices />}      />
              <Route path="lodges"          element={<Lodges />}       />
              <Route path="lodges/:id"      element={<LodgeDetail />}  />
              <Route path="access-points"   element={<AccessPoints />} />
              <Route path="payments"        element={<Payments />}     />
              <Route path="sessions"        element={<Sessions />}     />
              <Route path="outages"         element={<Outages />}      />
              <Route path="credits"         element={<Credits />}      />
              <Route path="analytics"       element={<Analytics />}    />
              <Route path="config"          element={<Config />}       />
              <Route path="logs"            element={<AdminLogs />}    />
              <Route path="broadcast"       element={<Broadcast />}    />
              <Route path="*"               element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}